const config = {
    "region": process.env.REACT_APP_REGION,
    'accessKeyId': process.env.REACT_APP_ACCESS_KEY,
    'secretAccessKey': process.env.REACT_APP_SECRET_KEY
}

export default config;